var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 16.0417H16.0417V4.375H4.375V16.0417ZM7.29167 7.29167H13.125V13.125H7.29167V7.29167Z",
    fill: "#A6CE50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 30.6252H16.0417V18.9585H4.375V30.6252ZM7.29167 21.8752H13.125V27.7085H7.29167V21.8752Z",
    fill: "#A6CE50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.959 4.375V16.0417H30.6257V4.375H18.959ZM27.709 13.125H21.8757V7.29167H27.709V13.125Z",
    fill: "#A6CE50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8757 18.9585H18.959V21.8752H21.8757V18.9585Z",
    fill: "#A6CE50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7917 21.875H21.875V24.7917H24.7917V21.875Z",
    fill: "#A6CE50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8757 24.7915H18.959V27.7082H21.8757V24.7915Z",
    fill: "#A6CE50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7917 27.7085H21.875V30.6252H24.7917V27.7085Z",
    fill: "#A6CE50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7077 24.7915H24.791V27.7082H27.7077V24.7915Z",
    fill: "#A6CE50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7077 18.9585H24.791V21.8752H27.7077V18.9585Z",
    fill: "#A6CE50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalVector);
export default __webpack_public_path__ + "static/media/modal-vector.0c652fe39a7fc0f1c5b0e3cd8e4edcf5.svg";
export { ForwardRef as ReactComponent };